import React, { useContext, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import { AppContext } from '../services/AppContext';
import AuthContext from '../context/auth-context';

import Header from '../components/Header';
import Sidebar from '../components/Sidebar';

import Home from '../pages/Home';
import InformacionAplicante from '../pages/InformacionAplicante';
import Login from '../pages/Login';
import Pagos from '../pages/Pagos';
import PagoAdmision from '../pages/PagoAdmision';
import PasswordRecovery from '../pages/PasswordRecovery';
import Register from '../pages/Register';

import 'bootstrap/dist/css/bootstrap.min.css';
import classes from './App.module.css';
import PasswordNew from '../pages/PasswordNew';

function App() {

  const authContext = useContext(AuthContext);

  const [showMenu, setShowMenu] = useState(false);
  const [appValues, setAppValues] = useState({
    showInfo: true,
    perfil: 0,
    infoAplicanteEnabled: true,
    infoAplicante: false,
    datosPersonales: false,
    contacto: false,
    estudiosSuperiores: false,
    experienciaLaboral: false,
    pagoAdmision: 'PENDIENTE'
  });

  const menuToggleHandler = () => {
    setShowMenu(showMenu => !showMenu);
  };

  return (
    <>
      <Router  basename={"/posgrado"}>
        <AppContext.Provider value={{ appValues, setAppValues }}>
          <div className={classes.bgImage}></div>
          <Header onMenuToggle={menuToggleHandler} toggleMenu={showMenu} />
          <Sidebar toggleMenu={showMenu} />
          <main className={classes.content}>
            <div className="container py-5">
              <Routes>
                {!authContext.isLoggedIn && <Route path='/login' exact element={<Login />} />}
                {!authContext.isLoggedIn && <Route path='/registro' exact element={<Register />} />}
                {!authContext.isLoggedIn && <Route path='/recuperacion-password' element={<PasswordRecovery />} />}
                {!authContext.isLoggedIn && <Route path='/crear-password/:token' element={<PasswordNew />} />}
                {!authContext.isLoggedIn && <Route path='*' element={<Navigate replace to="/login"/>} />}

                {authContext.isLoggedIn && <Route path='/' exact element={<Home />} />}
                {authContext.isLoggedIn && <Route path='/informacion-aplicante' element={<InformacionAplicante />} />}
                {authContext.isLoggedIn && <Route path='/pago-admision' element={<PagoAdmision />} />}
                {authContext.isLoggedIn && <Route path='/pagos' element={<Pagos />} />}
                {authContext.isLoggedIn && <Route path='*' element={<Navigate replace to="/"/>} />}
                
              </Routes>
            </div>
          </main>
        </AppContext.Provider>
      </Router>
    </>
  )
}

export default App